import EditLocation from "./EditLocation";

export default EditLocation;